import { alias, list, createModelSchema } from "serializr";
import { Schema } from "@/common/Schema";

import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";

import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";
import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";
import { RewardBunch } from "@/modules/redactor/models/reward/RewardBunch";

export class SmartOfferBundleSunkenRuins extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.SUNKEN_RUINS);

        this._currency = null;
        this._productPremium = null;

        this._reward = null;
        this._rewardPremium = null;

        this._collectionKind = null;
        this._maxCollectionLevel = 0;
        this._fuelKind = null;

        this._traderKinds = [];
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get rewardPremium() {
        return this._rewardPremium;
    }

    set rewardPremium(value) {
        this._rewardPremium = value;
    }

    get productPremium() {
        return this._productPremium;
    }

    set productPremium(value) {
        this._productPremium = value;
    }

    get collectionKind() {
        return this._collectionKind;
    }

    set collectionKind(value) {
        this._collectionKind = value;
    }

    get maxCollectionLevel() {
        return this._maxCollectionLevel;
    }

    set maxCollectionLevel(value) {
        this._maxCollectionLevel = value;
    }

    get fuelKind() {
        return this._fuelKind;
    }

    set fuelKind(value) {
        this._fuelKind = value;
    }

    get traderKinds() {
        return this._traderKinds;
    }

    set traderKinds(value) {
        this._traderKinds = value;
    }

    valid() {
        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (!this.reward || this.reward.empty()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        if (this.rewardPremium && !this.rewardPremium.valid()) {
            return false;
        }

        if (!this.productPremium || !RedactorUtils.getProduct(this.productPremium)) {
            return false;
        }

        if (!ItemKindModel.is(this.collectionKind) || ItemKindModel.isNone(this.collectionKind) || ItemKindModel.isAny(this.collectionKind)) {
            return false;
        }

        if (!Number.isInteger(this.maxCollectionLevel) || this.maxCollectionLevel < 0) {
            return false;
        }

        if (!ItemKindModel.is(this.fuelKind) || ItemKindModel.isNone(this.fuelKind) || ItemKindModel.isAny(this.fuelKind)) {
            return false;
        }

        if (!this.traderKinds || this.traderKinds.length === 0) {
            return false;
        }

        if (this.traderKinds.some(v => !ItemKindModel.is(v) || ItemKindModel.isNone(v) || ItemKindModel.isAny(v))) {
            return false;
        }

        return super.valid();
    }

    empty() {
        if (!this.reward || this.reward.empty()) {
            return true;
        }

        if (!this.traderKinds || this.traderKinds.length === 0) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleSunkenRuins());
        } else if (target instanceof SmartOfferBundleSunkenRuins) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleSunkenRuins, {
    _currency: alias("currency", CurrencyKindModel.schema()),
    _productPremium: alias("product_premium", Schema.primitive()),

    _reward: alias("reward", RewardBunch.schema()),
    _rewardPremium: alias("reward_premium", RewardBunch.schema()),

    _collectionKind: alias("collection_kind", ItemKindModel.schema()),
    _maxCollectionLevel: alias("max_collection_level", Schema.primitive()),
    _fuelKind: alias("fuel_kind", ItemKindModel.schema()),
    _traderKinds: alias("trader_kinds", list(ItemKindModel.schema())),
});
